/*
 *   File : confirm.js
 *   Author : https://evoqins.com
 *   Description : COnfirm modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React, { useEffect, useState } from 'react';

//Custom components
import { Icon } from '../Icon';
import { PrimaryButton, SecondaryButton } from '../Buttons';
import { CustomSelectBox, CustomTextInput } from '../FormElements';
import { toast } from 'react-toastify';
import { APIService } from '../../Service';


const ManageVideoModal = (props) => {

    const [selectedType, setSelectedType] = useState(null);
    const [selectedTypeError, setSelectedTypeError] = useState("");

    const [videoUrl, setVideoUrl] = useState("");
    const [videoUrlError, setVideoUrlError] = useState("");
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        setSelectedTypeError("");
        setVideoUrlError("");
    }, [selectedType]);

    useEffect(() => {
        setVideoUrlError("");
    }, [videoUrl]);

    useEffect(() => {
        if (props.data) {
            if (props.data?.type) {
                setSelectedType({ value: props.data?.type, label: props.data?.video_key });
            } else {
                setSelectedType(null);
            }

            if (props.data?.video_url) {
                setVideoUrl(props.data?.video_url);
            } else {
                setVideoUrl("");
            }
        } else {
            setSelectedType(null);
            setVideoUrl("");
        }
    }, [props.data]);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("manage-video-modal-close");
        button.click();
        props.handleClose();
    };

    // handle confirm 
    const _handleConfirm = () => {
        let is_valid = true;
        if (selectedType === null) {
            setSelectedTypeError("Please select type");
            is_valid = false;
        }
        if (videoUrl.trim().length === 0) {
            setVideoUrlError("Please enter video URL");
            is_valid = false;
        }
        if (is_valid === true) {
            _updateVideo();
        }
    };

    // API - Update video
    const _updateVideo = () => {
        setLoader(true);
        let is_post = true;
        let url = 'video/update-video-url';
        let request = {
            "video_url": videoUrl || null,
            "type": selectedType?.value || null
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                toast.dismiss();
                toast.success(props.data?.video_url ? `The video has been successfully updated` : `The video has been successfully added`, { type: "success" });
                setTimeout(() => {
                    _handleCloseModal();
                    props.handleSuccess();
                }, 200);
            } else {
                toast.dismiss();
                toast.error(response.message, { type: "error" });
            }
            setLoader(false);
        })
    };


    return (
        <div className="modal fade"
            id="manage-video-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="ModalLabel"
            aria-hidden="true">

            <div className={`modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-28 `}>
                <span id='manage-video-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-28 overflow-hidden border-0 e-bg-white-dark">

                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-3">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            {props.data?.video_url ? "Edit Video" : "Add Video"}
                        </h6>
                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className='modal-body pt-0 pb-1 padding-32px-lr d-flex flex-column gap-3'>
                        <CustomSelectBox title='Type'
                            placeholder='Select type'
                            controlWidth='w-100'
                            required={true}
                            options={props.options}
                            loader={props.optionsLoader}
                            // isMulti={true}
                            // isSearchable={false}
                            // borderColor={`0.031rem solid ${Color.arsenic}`}
                            padding="0.75rem 1rem"
                            value={selectedType}
                            error={selectedTypeError}
                            onChange={(data) => setSelectedType(data)} />

                        <CustomTextInput label="Video URL"
                            placeholder="Enter video URL"
                            type="text"
                            autoFocus={true}
                            required={true}
                            value={videoUrl}
                            error={videoUrlError}
                            className="w-100 padding-12px-tb"
                            // inputType={2}
                            onKeyPress={_handleConfirm}
                            handleChange={(e) => setVideoUrl(e)} />

                    </div>

                    {/* Modal footer */}
                    <div className='modal-footer border-0 pt-4 padding-32px-lr padding-32px-bottom gap-4'>
                        <SecondaryButton name="Cancel"
                            paddingBlock="py-3 padding-54px-lr"
                            onClick={_handleCloseModal} />
                        <PrimaryButton name={props.data?.video_url ? "Update" : "Add"}
                            paddingBlock="padding-64px-lr py-3"
                            loader={loader}
                            onClick={_handleConfirm} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ManageVideoModal;
